<script>
export default {
    name: 'IlluDateChoix',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-date-choix"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M54 35V18a4 4 0 00-4-4H14a4 4 0 00-4 4v28a4 4 0 004 4h18M10 24h44m-34.5-5V9m25 10V9M32 19V9"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
            />
            <path
                d="M44 33c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm5.765 6l-7.43 7.49-4.1-4.133L37 43.603 42.353 49l1.235-1.246-.018-.018 7.43-7.49L49.765 39z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
